export const lyric07 = `Is it just me?
Is it just me?
I hate holding babies and people tryna save me
Think religion is a business where you pay for God's forgiveness
Modern art is borin', politicians are annoyin'
I don't think love lasts forever and old music was better
Am I just high
Or am I kinda right?
Is it just me or does anybody
Feel the way that I feel?
They're just not being real
Tell me, is it just me or is anybody
Thinking all the same shit?
They're just not saying it
Or is it just me?
Is it just me?
(Is it just me?)
Weddings are outdated, the show 'Friends' was overrated
I think rich kids have it easy and PDA is creepy
The internet's obnoxious, people my age make me nauseous
I think marijuana's classy and doing coke is trashy
Am I just high
Or am I kinda right?
Is it just me or does anybody
Feel the way that I feel?
They're just not being real
Tell me, is it just me or is anybody
Thinking all the same shit?
They're just not saying it
Or is it just me?
Is it just me?
(Is it just me?)
should probably bite my tongue, but
(I) can't be the only one, yeah
(I) should probably bite my tongue, but
(I) can't be the only one
Oh, is it just me or does anybody
Feel the way that I feel?
They're just not being real
Tell me, is it just me or is anybody
Thinking all the same shit?
They're just not saying it
Or is it just me?
Is it just me?
(Is it just me?)
should probably bite my tongue, but
(I) can't be the only one, yeah
(I) should probably bite my tongue, but
(I) can't be the only one`